module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedBlack.7c5f00d.eot";